import { useGotoEntryForCmdk } from './cmdk-entries/goto';
import { useGetIndexDbProjectsForCmdk } from './cmdk-entries/projects';
import { CommandGroup } from './types';

export const useCmdkEntries = (): Array<CommandGroup> => {
  const gotoEntries = useGotoEntryForCmdk();
  const projectEntries = useGetIndexDbProjectsForCmdk();

  return [gotoEntries, projectEntries];
};
